"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSortableHoc = require("react-sortable-hoc");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } // @ts-expect-error
var _ref = /*#__PURE__*/_react.default.createElement("path", {
  d: "M0 7.5v5h50v-5H0zm0 15v5h50v-5H0zm0 15v5h50v-5H0z",
  color: "#000"
});
function DragHandleIconUnstyled(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    width: "18",
    height: "18",
    viewBox: "0 0 50 50"
  }), _ref);
}
const DragHandleIcon = (0, _styledComponents.default)(DragHandleIconUnstyled)`
  display: block;
  width: 18px;
  height: 18px;
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.25;
  margin: 2px;

  &:hover {
    background-color: #c5c5c5;
  }
`;
const DragHandleTableCell = _styledComponents.default.td`
  width: 20px;
  user-select: none;
  cursor: pointer;
`;
var _ref2 = /*#__PURE__*/_react.default.createElement(DragHandleTableCell, null, /*#__PURE__*/_react.default.createElement(DragHandleIcon, null));
const DragHandle = (0, _reactSortableHoc.SortableHandle)(() => _ref2);
var _default = exports.default = DragHandle;